import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import axios from 'axios';

interface UseAccountCancelReturn {
  isLoading: boolean;
  error: string | null;
  accountCancel: () => Promise<boolean>;
}

export const useAccountCancel = (): UseAccountCancelReturn => {
  const navigate = useNavigate();
  const { signOut: storeSignOut, refreshToken } = useAuthStore();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const accountCancel = useCallback(async (): Promise<boolean> => {
    if (!refreshToken) {
      setError('인증 정보가 없습니다.');
      return false;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/auth/account_cancel`, {
        headers: {
          Authorization: refreshToken
        }
      });

      if (response.data.status) {
        storeSignOut();
        navigate('/');
        return true;
      } else {
        setError('회원탈퇴 처리에 실패했습니다.');
        return false;
      }
    } catch (error: any) {
      console.error('회원탈퇴 중 오류 발생:', error);
      
      if (error.response?.status === 401) {
        setError('인증이 만료되었습니다. 다시 로그인해주세요.');
        storeSignOut();
        navigate('/auth/signin');
      } else {
        setError('회원탈퇴 처리 중 오류가 발생했습니다.');
      }
      return false;
    } finally {
      setIsLoading(false);
    }
  }, [refreshToken, storeSignOut, navigate]);

  return { isLoading, error, accountCancel };
}; 